import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const WorkTeamsFormSkeleton: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" gap={3} mb={3}>
      <Skeleton height={40} variant="rounded" width="100%" />
      <Box display="flex" gap={3} width="100%">
        <Skeleton height={40} variant="rounded" width="100%" />
        <Skeleton height={40} variant="rounded" width="100%" />
      </Box>
      <Box display="flex" gap={3} width="100%">
        <Skeleton height={40} variant="rounded" width="100%" />
        <Skeleton height={40} variant="rounded" width="100%" />
      </Box>
    </Box>
  );
};
